if(!String.prototype.escapeHTML) {
  String.prototype.escapeHTML = function() {
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(this));
    return div.innerHTML;
  };
}

/*!
 * JavaScript Cookie v2.2.0
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
;(function (factory) {
  var registeredInModuleLoader = false;
  if (typeof define === 'function' && define.amd) {
    define(factory);
    registeredInModuleLoader = true;
  }
  if (typeof exports === 'object') {
    module.exports = factory();
    registeredInModuleLoader = true;
  }
  if (!registeredInModuleLoader) {
    var OldCookies = window.Cookies;
    var api = window.Cookies = factory();
    api.noConflict = function () {
      window.Cookies = OldCookies;
      return api;
    };
  }
}(function () {
  function extend () {
    var i = 0;
    var result = {};
    for (; i < arguments.length; i++) {
      var attributes = arguments[ i ];
      for (var key in attributes) {
        result[key] = attributes[key];
      }
    }
    return result;
  }

  function init (converter) {
    function api (key, value, attributes) {
      var result;
      if (typeof document === 'undefined') {
        return;
      }

      // Write

      if (arguments.length > 1) {
        attributes = extend({
          path: '/'
        }, api.defaults, attributes);

        if (typeof attributes.expires === 'number') {
          var expires = new Date();
          expires.setMilliseconds(expires.getMilliseconds() + attributes.expires * 864e+5);
          attributes.expires = expires;
        }

        // We're using "expires" because "max-age" is not supported by IE
        attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

        try {
          result = JSON.stringify(value);
          if (/^[\{\[]/.test(result)) {
            value = result;
          }
        } catch (e) {}

        if (!converter.write) {
          value = encodeURIComponent(String(value))
            .replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
        } else {
          value = converter.write(value, key);
        }

        key = encodeURIComponent(String(key));
        key = key.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent);
        key = key.replace(/[\(\)]/g, escape);

        var stringifiedAttributes = '';

        for (var attributeName in attributes) {
          if (!attributes[attributeName]) {
            continue;
          }
          stringifiedAttributes += '; ' + attributeName;
          if (attributes[attributeName] === true) {
            continue;
          }
          stringifiedAttributes += '=' + attributes[attributeName];
        }
        return (document.cookie = key + '=' + value + stringifiedAttributes);
      }

      // Read

      if (!key) {
        result = {};
      }

      // To prevent the for loop in the first place assign an empty array
      // in case there are no cookies at all. Also prevents odd result when
      // calling "get()"
      var cookies = document.cookie ? document.cookie.split('; ') : [];
      var rdecode = /(%[0-9A-Z]{2})+/g;
      var i = 0;

      for (; i < cookies.length; i++) {
        var parts = cookies[i].split('=');
        var cookie = parts.slice(1).join('=');

        if (!this.json && cookie.charAt(0) === '"') {
          cookie = cookie.slice(1, -1);
        }

        try {
          var name = parts[0].replace(rdecode, decodeURIComponent);
          cookie = converter.read ?
            converter.read(cookie, name) : converter(cookie, name) ||
            cookie.replace(rdecode, decodeURIComponent);

          if (this.json) {
            try {
              cookie = JSON.parse(cookie);
            } catch (e) {}
          }

          if (key === name) {
            result = cookie;
            break;
          }

          if (!key) {
            result[name] = cookie;
          }
        } catch (e) {}
      }

      return result;
    }

    api.set = api;
    api.get = function (key) {
      return api.call(api, key);
    };
    api.getJSON = function () {
      return api.apply({
        json: true
      }, [].slice.call(arguments));
    };
    api.defaults = {};

    api.remove = function (key, attributes) {
      api(key, '', extend(attributes, {
        expires: -1
      }));
    };

    api.withConverter = init;

    return api;
  }

  return init(function () {});
}));









/*
 *  Geo Tools
 *    Provides common tools and funcitons for geo related items, including
 *    callbacks etc.
 *
 *  Dependencies:
 *    js-cookie - Cookies is used to cache data.
 *
 *  Version:
 *    1.0.0 - 2018/09/20
 */
var GEO_CACHE_COOKIE_NAME = 'GeoDataCache';

function geoTools() {
  this.callbacks = [];

  //Check the cookie first and then we can start tracking geodata.
  if(typeof Cookies !== typeof undefined && typeof Cookies.get === "function") {
    var data = Cookies.get(GEO_CACHE_COOKIE_NAME);

    //Cookie may store it as a JSON object... test.
    if(typeof data === "string") {
      try {
        data = JSON.parse(data);
      } catch(e) {
        console.error(e);
        return;
      }
    }

    //TODO: better validation here.
    //this.geoData = data;
  }
}

geoTools.prototype = {
  fetchGeo: function(callback) {
    //First let's check if we already have the geo data
    if(typeof this.geoData !== typeof undefined) {
      return callback(this.geoData);//Immediately callback
    }

    //We don't have it, let's fetch and append the callback
    this.callbacks.push(callback);

    //Are we already fetching?
    if(typeof this.geoFetch !== typeof undefined) return;

    //Not fetching, fetch!
    //this.geoFetch = $.getJSON("//extreme-ip-lookup.com/json/", this.onGeoFetched.bind(this));
    this.geoFetch = $.ajax({
      url: 'https://api.ipdata.co/',
      method: "GET",
      data: {
        "api-key": "202009d24e29b484da88589d3304df46b03d3cdc86d2f0b1dbcda253"
      },
      success: this.onGeoFetched.bind(this),
      error: this.onGeoError.bind(this)
    });
  },

  onGeoError: function(e) {
    console.log(e);
  },

  onGeoFetched: function(data) {
    //Geo fetched
    this.geoData = data;
    for(var i = 0; i < this.callbacks.length; i++) {
      //Fire callback
      this.callbacks[i](data);
    }

    //Fire event
    $(document).trigger('onGeo', data);

    //Store the cookie
    if(typeof Cookies !== typeof undefined && typeof Cookies.set === "function") {
      Cookies.set(GEO_CACHE_COOKIE_NAME, data, { expires: 1 });
    }
  }
};

window.Geo = new geoTools();



/*
 *  Geo Location Popup
 *    Custom GeoLocation Popup Code
 *
 *  Dependencies:
 *    scripts/tools/geo.js
 *
 *  Version:
 *    1.0.0 - 2018/10/08
 */
var GEO_POPUP_REMEMBER_COOKIE = 'GeoPopupRemember';

function GeoPopup(container) {
  this.container = container;
  this.id = container.attr('data-section-id');
  this.remember = !(!container.attr('data-remember'));

  this.content = this.container.find('[data-geo-content]');
  this.goButton = this.container.find('[data-geo-go]');
  this.closeButton = this.container.find('[data-geo-close]');

  //Load in data
  this.data = window.GeoPopupData || [];

  //Event Handlers
  this.container.on('click', '[data-geo-close]', this.onGeoClose.bind(this));
  this.container.on('click', '[data-geo-go]', this.onGeoGo.bind(this));
  Geo.fetchGeo(this.onGeo.bind(this));
}

GeoPopup.prototype = {
  onGeo: function(geo) {
    var countryData = null;
    var intData = null;

    for(var i = 0; i < this.data.length; i++) {
      var data = this.data[i];
      var countryCodeArray = data.code.replace(/\s/g, '').split(',');
      var isCountry = false;

      for(var x = 0; x < countryCodeArray.length; x++) {
        var code = countryCodeArray[x];
        if(code == 'INT') {
          intData = data;
        }
        if(code != geo.country_code) continue;
        isCountry = true;
        break;
      }

      if(!isCountry) continue;

      //Is country
      countryData = data;
      break;
    }

    if(!countryData && !intData) return;
    this.useGeoData(countryData || intData);
  },

  useGeoData: function(data) {
    //Determine URL
    var url = data.domain;
    url = url.replace(/^(http(s)?)?(:)?(\/)?(\/)?/gim, '//');

    window.testMe = this.container;
    if(this.container.attr('data-relative')) {
      url += window.location.pathname;
      url += window.location.search;
      url += window.location.hash;
    }

    if(data.domain == window.location.hostname) return;

    var remember = Cookies.get(GEO_POPUP_REMEMBER_COOKIE);
    if(this.remember && remember === data.domain) return;

    //Force Redirect?
    if(data.redirect) {
      if(typeof Shopify !== typeof undefined && Shopify.designMode === true) {
        //Theme editor, don't actually redirect!
      } else {
        window.location.href = url;
      }
    }


    //Generate popup content
    var x = (window.GeoPopupMessage||"").replace(/\%country\%/gi, data.title);
    x = x.escapeHTML();
    x = x.replace('\n','<br />');

    //Set Popup content
    this.goButton.attr('href', url);
    this.goButton.attr('data-domain', data.domain);
    this.closeButton.attr('data-domain', data.domain);
    this.content.html(x);

    //Show popups
    this.openPopup();
  },

  openPopup: function() {
    if(!this.container.attr('data-enable')) return;
    $('html,body').addClass('is-geo-popup-visible');
    setTimeout(function() {
      this.container.addClass('is-visible');
    }.bind(this),1);
  },


  closePopup: function() {
    this.container.removeClass('is-visible');
    setTimeout(function() {
      $('html,body').removeClass('is-geo-popup-visible');
    }, 210);
  },

  onGeoClose: function(e) {
    e.preventDefault();
    e.stopPropagation();

    this.closePopup();
    this.rememberData(this.closeButton.attr('data-domain'));
  },

  onGeoGo: function(e) {
    this.rememberData(this.goButton.attr('data-domain'));
  },

  rememberData: function(d) {
    Cookies.set(GEO_POPUP_REMEMBER_COOKIE, d);
  }
};
(function($) {
  if(typeof $ === typeof undefined) return;
  $(document).ready(function() {
    $('[data-geo-popup]').each(function(e) {
      window.GeoPopups = window.GeoPopups || [];
      window.GeoPopups.push(new GeoPopup($(this)));
    });
  });
})(jQuery);


jQuery(window).on('load',function(){
    setTimeout(function(){
    	jQuery('.sd_getsizechart .sd_loaderimg').fadeOut('slow');
    },5000);
  });
